import { createAction } from '@ngrx/store';

export const loadCustomerOnboardingStatus = createAction(
  'Load onboarding status'
);
